export default function ({commit, state, dispatch}, data) {
    if (!data) {
        state.form.CertificateId = '';
        state.form.CertificateName = '';
        return;
    }
    state.form.CertificateId = data.value;
    state.form.CertificateName = data.label;
    if (data.PaymentId) {
        commit('set_load', {
            data: true,
        });
        dispatch('create_pay_edit', {id: data.PaymentId});
    }else{
        state.form.PaymentDirection = 0;
        if (data.ClientId) {
            dispatch('change_PaymentOperationID', 1);
            setTimeout(()=>{
                state.form.ContragentType = 1;
                state.form.ContragentID = data.ClientId;
                state.form.ContragentName = data.ClientName;
                state.form.Sum = data.Sum;
                state.form.BankCommission = data.BankCommission;
                state.form.CurrencyId = data.CurrencyId;
            })

        }
        if (data.PartnerId) {
            dispatch('change_PaymentOperationID', 3);
            setTimeout(()=>{
                state.form.ContragentType = 2;
                state.form.ContragentID = data.PartnerId;
                state.form.ContragentName = data.PartnerName;
                state.form.PartnerLegalEntityId = data.PartnerLegalId;
                state.form.PartnerLegalEntityName = data.PartnerLegalName;
                state.form.Sum = data.Sum;
                state.form.BankCommission = data.BankCommission;
                state.form.CurrencyId = data.CurrencyId;
            })

        }
    }
}
